export { RetailsSkeleton } from './RetailsSkeleton';
